module.exports = {"610581001":"新城街道","610581002":"金城街道","610581100":"龙门镇","610581101":"桑树坪镇","610581103":"芝川镇","610581104":"西庄镇","610581106":"芝阳镇","610581107":"板桥镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610581.json
// module id = 2831
// module chunks = 0